import React from "react";
import { withStyles } from "@material-ui/core/styles";
import { useStyles } from "../../../assets/jss/DialogTC";
import IconButton from "@material-ui/core/IconButton";
import Typography from "@material-ui/core/Typography";
import CustomDialog from "../../CustomComponents/CustomDialog/CustomDialog";
import CustomDialogContent from "../../CustomComponents/CustomDialogContent/CustomDialogContent";
import CustomDialogAction from "../../CustomComponents/CustomDialogAction/CustomDialogAction";
import CloseIcon from "../../../assets/images/close.svg";
import CustomButton from "../../CustomComponents/CustomButton/CustomButton";
import { useTranslation } from "react-i18next";
const DialogContent = withStyles((theme) => ({}))(CustomDialogContent);

const DialogActions = withStyles((theme) => ({}))(CustomDialogAction);

export default function ViewActionDialog(props:any) {
    const { t } = useTranslation();
    const classes = useStyles();
    const [open, setOpen] = React.useState(props.dialogOpen);
    const handleClose = (confirmDelete) => {
        setOpen(false);
        props.dialogClose(false, confirmDelete, false);
    };

    const handleReplace = (confirmReplace) => {
        setOpen(false);
        props.dialogClose(false, confirmReplace, true);
    }


    React.useEffect(() => {
        setOpen(props.dialogOpen);
    }, [props.dialogOpen]);

    return (
        <CustomDialog
            onClose={() => handleClose(false)}
            aria-labelledby="customized-dialog-title"
            open={open}
            className={classes.dialogWrapper}
        >
            <IconButton
                aria-label="close"
                className={classes.closeButton}
                onClick={() => handleClose(false)}
            >
                <img src={CloseIcon} />
            </IconButton>
            <DialogContent className={classes.dialogContentWrapper}>
                <Typography className={classes.dialogTitleName}>
                    {`"${props.viewName}"`}
                </Typography>
                <Typography className={classes.dialogHead}>
                    {t("THIS_VIEW_NAME_IS_ALREADY_EXIST")}
                </Typography>
                <Typography className={classes.dialogContentSubtitle}>
                    {t("VIEW_NAME_YOU_HAVE_ENTERED_ALREADY_EXISTS")}
                </Typography>
                <Typography className={classes.dialogContentSubtitle}>
                    {t("WHAT_WOULD_YOU_LIKE_TO_DO")}
                </Typography>
            </DialogContent>
            <DialogActions className={classes.dialogActionWrapper}>
                <CustomButton
                    autoFocus
                    onClick={() => handleClose(false)}
                    color="primary"
                    className={classes.noBg}
                    defaultrounded="true"
                >
                    {t("CANCEL")}
                </CustomButton>
                <CustomButton
                    className={classes.deleteView}
                    autoFocus
                    onClick={() => handleClose(true)}
                    variant="outlined"
                    //className={classes.noBackground}
                    defaultrounded="true"
                >
                    {t("KEEP_BOTH")}
                </CustomButton>
                <CustomButton
                    className={classes.deleteView}
                    autoFocus
                    onClick={() => handleReplace(true)}
                    variant="contained"
                    color="primary"
                    defaultrounded="true"
                >
                    {t("REPLACE")}
                </CustomButton>
            </DialogActions>
        </CustomDialog>
    );
}
